module.exports = __webpack_public_path__ + "static/media/jocelyn-goldfein.6ea4875b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/jocelyn-goldfein.jpeg
// module id = 261
// module chunks = 0